import { AvatarV2, Badge, ColorOption } from '@cimplico/components';
import { Group } from '../../types/group';
import { parseTitle } from '../../utilities/formatting';
import FyiLogo from '../../assets/fyi.png';

type GroupDetailsProps = {
    group: Group;
    color: ColorOption;
};

function GroupDetails({ group, color }: GroupDetailsProps): JSX.Element {
    return (
        <div className="flex items-start">
            <div className="flex-none">
                <AvatarV2 alt={`${parseTitle(group.name)}`} size="xl" rounded={false} color={color} />
            </div>
            <div className="flex-col flex-wrap pl-8 max-w-4xl">
                <div className="flex items-center gap-2">
                    <h1 className="leading-none text-3xl text-gray-900 font-bold dark:text-white/[0.87] max-w-[50ch]">{group.name}</h1>
                    {group.integrations.fyi && <img src={FyiLogo} className="w-6 h-6 shrink-0" />}
                </div>
                <p className="text-sm text-gray-800 pt-2 max-w-[250ch]">{group.description}</p>
            </div>
        </div>
    );
}
export default GroupDetails;
